module.exports = __webpack_public_path__ + "img/image-1.f4e544f4.jpg";